// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Segment } from 'semantic-ui-react';
// local
// views
// actions
import { closeSaveUpdate, ACTION } from 'app/redux/actions/modal/save-update-modal.action';
import Notification from 'app/components/commons/notification/Notification';

//import './SaveUpdateNewModal.scss';
import styles from './SaveUpdateNewModal.module.scss';

// REFACTOR Realizar refatoração a fim de eliminar o SaveUpdateNewModal e utilizar o SaveUpdateModal
// EXPLANATION Essa refatoração consistirá em utilizar o componente SaveUpdateNewModal com o nome SaveUpdateModal e realizar sua sustituição em todo o sistema.

class SaveUpdateNewModal extends Component {
  componentWillUnmount = () => this.onClose();

  onClose = () => {
    this.props.options.dispatch(closeSaveUpdate());
  };

  onSubmit = () => {
    const { onConfirmModal, action } = this.props.options;
    if (onConfirmModal && onConfirmModal(action)) {
      this.onClose();
    }
  };

  render() {
    const { /* id, */ children, options } = this.props;
    const { isOpened, action, title, error, loading, size = 'tiny' } = options;

    return (
      <Modal
        //id={id}
        id={styles.modal}
        open={isOpened}
        onClose={this.onClose}
        closeOnDimmerClick={false}
        size={size}
        style={{ borderRadius: '14px' }}
      >
        <Modal.Header style={{ textAlign: 'center' }}>
          {action === ACTION.ADD
            ? 'ADICIONAR'
            : action === ACTION.UPDATE
            ? 'ATUALIZAR'
            : 'IMPORTAR'}{' '}
          {title}
        </Modal.Header>
        <Segment vertical loading={loading}>
          {error ? <Notification message={error.errors} isError /> : null}
          <Modal.Content className={styles.content}>{children}</Modal.Content>
          <Modal.Actions style={{}}>
            <Button
              /* id='cancel-btn' */
              id={styles.cancelBtn}
              content='Cancelar'
              onClick={this.onClose}
            />
            <Button
              //id='save-btn'
              id={styles.saveBtn}
              content={action === ACTION.IMPORT ? 'Importar' : 'Salvar'}
              onClick={this.onSubmit}
            />
          </Modal.Actions>
        </Segment>
      </Modal>
    );
  }
}

SaveUpdateNewModal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  options: PropTypes.object
};

export default SaveUpdateNewModal;
